/*
 * @File: Do not edit
 * @Contact: lyhzyy0819@gmail.com
 * @License: (C)Copyright 2018-2024
 * @Modify Time: Do not edit
 * @Author: lyh
 * @Version: 1.0
 * @Description: 
 */
import { createRouter, createWebHistory } from 'vue-router'

// 页面路由
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/fuzozo-quiz-zh/:pathMatch(.*)*',
    name: 'FuzozoQuizStatic',
    beforeEnter: (to) => {
      const basePath = '/fuzozo-quiz-zh';
      const queryHash = to.fullPath.slice(to.path.length);

      if (to.path.endsWith('/index.html')) {
        return false;
      }

      const suffix = to.path.slice(basePath.length).replace(/^\/+|\/+$/g, '');
      const targetPath = suffix
        ? `${basePath}/${suffix}/index.html`
        : `${basePath}/index.html`;

      window.location.replace(`${targetPath}${queryHash}`);
      return false;
    }
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: () => import('../views/Welcome.vue')
  },
  {
    path: '/detail/:id',
    name: 'Detail',
    component: () => import('../views/Detail.vue')
  },
  {
    path: '/invite-code',
    name: 'InviteCode',
    component: () => import('../views/InviteCode.vue')
  },
  {
    path: '/invite-code-input',
    name: 'InviteCodeInput',
    component: () => import('../views/InviteCodeInput.vue')
  },
  {
    path: '/invite-code-guide',
    name: 'InviteCodeGuide',
    component: () => import('../views/InviteCodeGuide.vue')
  },
  {
    path: '/reward',
    name: 'Reward',
    component: () => import('../views/RewardPage.vue')
  },
  {
    path: '/reward-test',
    name: 'RewardTest',
    component: () => import('../views/RewardPage_backup.vue')
  },
  {
    path: '/reward-official',
    name: 'RewardOfficial',
    component: () => import('../views/ReWardPageOfficial.vue')
  },
  {
    path: '/growth-reward',
    name: 'GrowthReward',
    component: () => import('../views/GrowthReward.vue')
  },
  {
    path: '/growth-reward-long',
    name: 'GrowthRewardLong',
    component: () => import('../views/GrowthRewardLong.vue')
  },
  {
    path: '/pag-test',
    name: 'PagTest',
    component: () => import('../views/PagTest.vue')
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('../views/PrivacyPolicy.vue')
  },
  {
    path: '/user-agreement',
    name: 'UserAgreement',
    component: () => import('../views/UserAgreement.vue')
  },
  {
    path: '/third-party-sharing',
    name: 'ThirdPartySharing',
    component: () => import('../views/ThirdPartySharing.vue')
  },
  {
    path: '/personal-info-collection',
    name: 'PersonalInfoCollection',
    component: () => import('../views/PersonalInfoCollection.vue')
  },
  {
    path: '/digital-life-qa',
    name: 'DigitalLifeQA',
    component: () => import('../views/DigitalLifeQA.vue')
  },
  {
    path: '/device-help-qa',
    name: 'DeviceHelpQA',
    component: () => import('../views/DeviceHelpQADispatcher.vue')
  },
  {
    path: '/device-help-qa-android',
    name: 'DeviceHelpQAAndroid',
    redirect: (to) => ({
      path: '/device-help-qa',
      query: to.query,
      hash: to.hash
    })
  },
  {
    path: '/pdf-manual',
    name: 'PdfManual',
    component: () => import('../views/PdfManual.vue')
  },
  {
    path: '/app',
    name: 'AppDownload',
    component: () => import('../views/AppDownload.vue')
  },
  {
    path: '/qixi-activity',
    name: 'QixiActivity',
    component: () => import('../views/QixiActivity.vue')
  },
  {
    path: '/value-added-service-agreement',
    name: 'ValueAddedServiceAgreement',
    component: () => import('../views/ValueAddedServiceAgreement.vue')
  },
  {
    path: '/country-region-select',
    name: 'CountryRegionSelect',
    component: () => import('../views/CountryRegionSelect.vue')
  },
  {
    path: '/voice-collection-authorization-agreement',
    name: 'VoiceCollectionAuthorizationAgreement',
    component: () => import('@/views/VoiceCollectionAuthorizationAgreement.vue'),
    meta: { title: '用户声音及AI生成授权协议' }
  },
  {
    path: '/voiceprint-recognition-service-privacy-statement',
    name: 'VoiceprintRecognitionServicePrivacyStatement',
    component: () => import('../views/VoiceprintRecognitionServicePrivacyStatement.vue')
  },
  {
    path: '/report',
    name: 'ReportAccount',
    component: () => import('../views/ReportAccount.vue'),
    meta: { title: '举报' }
  },
  {
    path: '/community-guidelines',
    name: 'CommunityGuidelines',
    component: () => import('../views/CommunityGuidelines.vue'),
    meta: { title: '芙崽Fuzozo社区公约' }
  },
  {
    path: '/overseas-real-name-auth-help',
    name: 'OverseasRealNameAuthHelp',
    component: () => import('../views/OverseasRealNameAuthHelp.vue'),
    meta: {
      title: '港澳台境外用户认证帮助',
      appBackground: '#fffcd1'
    }
  },
  {
    path: '/newbie-task',
    name: 'NewbieTask',
    component: () => import('../views/NewbieTask.vue')
  },
  {
    path: '/daily-task',
    name: 'DailyTask',
    component: () => import('../views/DailyTask.vue')
  },
  {
    path: '/video-showcase',
    alias: '/video-showcas',
    name: 'VideoShowcase',
    component: () => import('../views/VideoShowcase.vue')
  },
  {
    path: '/spring-festival',
    name: 'SpringFestival',
    component: () => import('../views/SpringFestival.vue')
  },
  {
    path: '/data-traffic-purchase-agreement',
    name: 'DataTrafficPurchaseAgreement',
    component: () => import('../views/DataTrafficPurchaseAgreement.vue'),
    meta: { title: 'Fuzozo芙崽数据流量购买协议' }
  },
  // ---- 活动页 ----
  {
    path: '/activity/city-dialect',
    name: 'CityDialectActivity',
    component: () => import('../views/activity/CityDialectActivity.vue'),
    meta: {
      title: '城市限定普通话+方言',
      appBackground: '#fff'
    }
  },
  {
    path: '/activity/ended',
    name: 'ActivityEnded',
    component: () => import('../views/activity/ActivityEnded.vue'),
    meta: { title: '活动已结束' }
  },
  {
    path: '/activity/honeycomb-voucher-notice',
    name: 'HoneycombVoucherNotice',
    component: () => import('../views/activity/HoneycombVoucherNotice.vue'),
    meta: { title: '蜂窝版100元代金券公告' }
  },
  {
    path: '/activity/tianma-xingkong',
    name: 'TianmaXingkongActivity',
    component: () => import('@/views/activity/TianmaXingkongActivity.vue'),
    meta: { title: '天马行空', appBackground: '#ede8f5' }
  },
  {
    path: '/activity/cj7-teaser-campaign',
    name: 'Cj7TeaserCampaign',
    component: () => import('@/views/activity/Cj7TeaserCampaign.vue'),
    meta: { title: '7仔，好久不见', appBackground: '#040000' }
  },
  {
    path: '/activity/summer-nfc-charging-nest-derivatives',
    name: 'SummerNFCChargingNestDerivatives',
    component: () => import('../views/activity/SummerNFCChargingNestDerivatives.vue'),
    meta: { title: '浮空岛治愈上线' }
  },
  {
    path: '/activity/cat-series',
    name: 'CatSeries',
    component: () => import('../views/activity/CatSeries.vue'),
    meta: { title: '猫猫系列' }
  },
  {
    path: '/activity/kapibala',
    name: 'KapibalaActivity',
    component: () => import('../views/activity/KapibalaActivity.vue'),
    meta: { title: '卡皮吧啦活动' }
  },
  {
    path: '/activity/magic-academy',
    name: 'MagicAcademyActivity',
    component: () => import('../views/activity/MagicAcademyActivity.vue'),
    meta: {
      title: '魔法学院',
      disableRouteTransition: true,
      appBackground: '#000'
    }
  },
  {
    path: '/activity/magic-test',
    name: 'MagicTestActivity',
    component: () => import('../views/activity/MagicTestActivity.vue'),
    meta: {
      title: '测试你的专属魔法',
      disableRouteTransition: true,
      appBackground: '#000'
    }
  },
  {
    path: '/activity/anniversary',
    name: 'AnniversaryActivity',
    component: () => import('../views/activity/AnniversaryActivity.vue'),
    meta: { title: '星愿周年庆' }
  },
  {
    path: '/activity/anniversary-rules',
    name: 'AnniversaryRules',
    component: () => import('../views/activity/AnniversaryRules.vue'),
    meta: { title: '星愿周年庆活动规则' }
  },
  // 可以添加更多路由
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 全局前置守卫，可用于参数处理和权限验证
router.beforeEach((to, from, next) => {
  // 可以在这里处理来自第三方app的通用参数
  console.log('Route params:', to.params)
  console.log('Query params:', to.query)
  next()
})

export default router
